import React, { useCallback } from 'react';
import { combineBridges, createEventChannel, createEventChannelBridgeFactory, createTransformer, withClient, withFilter } from '@atlassian/commerce-events-bridge-utils-react';
import { nestListeners } from '@atlassian/commerce-events-core-react';
export { withClient, combineBridges, withFilter, createTransformer };
var createGasV3UIEventChannel = createEventChannel;
/**
 * @deprecated
 */

export var createGasV3UIEventChannelBridge = createEventChannelBridgeFactory(createGasV3UIEventChannel, function (client, payload) {
  return client.sendUIEvent(payload);
});
var createGasV3ScreenEventChannel = createEventChannel;
/**
 * @deprecated
 */

export var createGasV3ScreenEventChannelBridge = createEventChannelBridgeFactory(createGasV3ScreenEventChannel, function (client, payload) {
  return client.sendScreenEvent(payload);
});
var createGasV3TrackEventChannel = createEventChannel;
/**
 * @deprecated
 */

export var createGasV3TrackEventChannelBridge = createEventChannelBridgeFactory(createGasV3TrackEventChannel, function (client, payload) {
  return client.sendTrackEvent(payload);
});
var createGasV3OperationalEventChannel = createEventChannel;
/**
 * @deprecated
 */

export var createGasV3OperationalEventChannelBridge = createEventChannelBridgeFactory(createGasV3OperationalEventChannel, function (client, payload) {
  return client.sendOperationalEvent(payload);
});

/**
 * @deprecated
 */
export var createGasV3EventChannelBridge = function createGasV3EventChannelBridge() {
  var ui = createGasV3UIEventChannelBridge();
  var screen = createGasV3ScreenEventChannelBridge();
  var track = createGasV3TrackEventChannelBridge();
  var operational = createGasV3OperationalEventChannelBridge();

  var Bridge = function Bridge(_ref) {
    var children = _ref.children,
        client = _ref.client;
    return /*#__PURE__*/React.createElement(ui.Bridge, {
      client: client
    }, /*#__PURE__*/React.createElement(screen.Bridge, {
      client: client
    }, /*#__PURE__*/React.createElement(track.Bridge, {
      client: client
    }, /*#__PURE__*/React.createElement(operational.Bridge, {
      client: client
    }, children))));
  };

  return {
    /**
     * @internal
     * Used by integration packages
     */
    ui: ui,

    /**
     * @internal
     * Used by integration packages
     */
    screen: screen,

    /**
     * @internal
     * Used by integration packages
     */
    track: track,

    /**
     * @internal
     * Used by integration packages
     */
    operational: operational,

    /**
     * A component that listens to GasV3 events being dispatched by its children and
     * sends them using the {@link AnalyticsWebClientType}.
     */
    Bridge: Bridge
  };
};
export var GasV3Integration = function GasV3Integration(_ref2) {
  var client = _ref2.client,
      GasV3UIEventListener = _ref2.GasV3UIEventListener,
      GasV3ScreenEventListener = _ref2.GasV3ScreenEventListener,
      GasV3TrackEventListener = _ref2.GasV3TrackEventListener,
      GasV3OperationalEventListener = _ref2.GasV3OperationalEventListener,
      children = _ref2.children;
  return nestListeners(children, [{
    Listener: GasV3UIEventListener,
    onEvent: useCallback(function (payload) {
      return client.sendUIEvent(payload);
    }, [client])
  }, {
    Listener: GasV3ScreenEventListener,
    onEvent: useCallback(function (payload) {
      return client.sendScreenEvent(payload);
    }, [client])
  }, {
    Listener: GasV3TrackEventListener,
    onEvent: useCallback(function (payload) {
      return client.sendTrackEvent(payload);
    }, [client])
  }, {
    Listener: GasV3OperationalEventListener,
    onEvent: useCallback(function (payload) {
      return client.sendOperationalEvent(payload);
    }, [client])
  }]);
};